import axios from 'axios'

const { REACT_APP_BASE_URL_MOCK } = process.env
export const urlMeHome = '/bff-vle/me/home'
export const mockApiUrl = `${REACT_APP_BASE_URL_MOCK}${urlMeHome}`

export const getHomeData = async () => {
  const url = urlMeHome
  const { data } = await axios.get(url)
  return data
}
